import React, {useState} from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress, Typography} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { useDispatch, useSelector } from 'react-redux';
import { checkListSelector, uploadCheckLIstInfo } from '../../redux/reducers/normative-documents-reducer';




const AddDocumentCheckList= () => {

    const dispatch = useDispatch()
    const {loading} = useSelector(checkListSelector)
    const [chosenFile, setChoseFile] = useState(null)

    const handleUploadButtonClick = () => {
        dispatch(uploadCheckLIstInfo(chosenFile))
        setChoseFile(null)
    }

    const onFileChange = (event) => {
        setChoseFile(event.target.files[0])
    }

    return (
        <div style={{border: '2px solid #000', marginTop: '50px', padding: '10px'}}>
                <Grid container direction={'column'} spacing={2}>
                    <Grid item>
                        <input
                            color="primary"
                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            type="file"
                            onChange={onFileChange}
                            id="icon-button-file-1"
                            style={{display: 'none'}}
                        />
                        <label htmlFor="icon-button-file-1">
                            <Button
                                variant="contained"
                                size="small"
                                component="span"
                                color="primary"
                                disabled={loading}
                            >
                                Выбрать файл
                            </Button>
                        </label>
                    </Grid>
                    <Grid item>
                        <Typography>
                            {chosenFile ? `Выбран файл "${chosenFile.name}"` : 'Выберите файл для загрузки'}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <LinearProgress hidden={!loading}/>
                    </Grid>
                </Grid>
                <Grid container justifyContent={'flex-end'}>
                    <Grid item>
                        <Button onClick={handleUploadButtonClick} disabled={!Boolean(chosenFile)}>
                            Загрузить
                        </Button>
                    </Grid>
                </Grid>
        </div>
    );
};

export default AddDocumentCheckList;